import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64e6bdc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tilte" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "订单号", -1))
const _hoisted_3 = {
  key: 0,
  class: "button-line van-hairline--top nongfu-button-wrap"
}
const _hoisted_4 = {
  key: 0,
  class: "button-tips"
}

import { useRouter } from 'vue-router'
import { OrderListItem } from '@/types/jijia'
import { List, PullRefresh, Button } from 'vant'
import { showConfirmModal, showToastFail, showToastLoading } from '@/utils/tools'
import { getThousandMoney } from '@/utils/index'
import { getJijiaOrderList } from '@/apis/jijia'
import { GetJijiaOrderListItem } from '@/types/jijia'
import { XssCommonPageListQuery } from '@/types/public'
import { applyVerifyDevice } from '@/apis/jijia'
import useCommonList, { PageParams, PageListResut } from '@/compositions/useCommonList'
import AppHeader from '@/components/Header.vue'
import dayjs from 'dayjs'
import BaseInfoList from './components/base-info-list.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'order-list',
  setup(__props) {

const waitVerifyDeviceValueStyle = {
  color: '#00B860',
}
const verifyFailtDeviceValueStyle = {
  color: '#FF902B',
}
const $router = useRouter()
function getStatusValueStyle(status: number) {
  if (status === 56) {
    return waitVerifyDeviceValueStyle
  } else if (status === 57) {
    return verifyFailtDeviceValueStyle
  }
  return null
}
function formatDayToNumberDay(milliseconds: number, num: number) {
  const DateItem = new Date(milliseconds + num * 24 * 60 * 60 * 1000)
  DateItem.setHours(23)
  DateItem.setMinutes(59)
  DateItem.setSeconds(59)
  return DateItem.getTime()
}
async function queryList(
  params: PageParams & XssCommonPageListQuery
): Promise<PageListResut<OrderListItem>> {
  try {
    const data = await getJijiaOrderList({
      ...params,
      status: '55,56,57,99,100',
    })
    return {
      ...data,
      data: data.data.map((item: GetJijiaOrderListItem) => {
        let orderInfo = [
          {
            label: '订单状态',
            value: item.status_text,
            valueStyle: getStatusValueStyle(item.status),
          },
          {
            label: '验机网点',
            value: item.need_check_uav === 2 ? item.inspection_service_station_name : '无需验机',
          },
          { label: '订单支付金额', value: `¥ ${getThousandMoney(item.pay_amount)}` },
        ]
        if (item.pay_at) {
          orderInfo.push({ label: '订单支付时间', value: item.pay_at })
        }
        if (item.refunded_amount) {
          orderInfo = orderInfo.concat([
            {
              label: '已退款金额',
              value: `¥ ${getThousandMoney(item.refunded_amount)}`,
            },
            {
              label: '最后退款时间',
              value: item.refunded_at,
            },
          ])
        }
        return {
          ...item,
          pay_at: 'string',
          orderInfo,
          snInfo: [
            { label: `SN:${item.serial_number}(${item.product_definition_name})`, value: '' },
          ],
          showVerifyDeviceButton: item.status === 57,
          showApplyInvoiceButton:
            (item.status === 100 || item.status === 99) &&
            !item.invoice_apply_guid &&
            Date.now() - formatDayToNumberDay(dayjs(item.pay_at).valueOf(), 30) <= 0 &&
            item.pay_amount - item.refunded_amount > 0,
        }
      }),
    }
  } catch (error) {
    return Promise.reject(error)
  }
}
const {
  refreshing,
  loading,
  requestError,
  finished,
  onRefresh,
  dataList,
  queryHandle,
  finishedText,
} = useCommonList<OrderListItem, PageParams>(queryList, {})

async function applyVerifyAgain(item: OrderListItem) {
  try {
    await showConfirmModal({
      message: '是否确认重新申请重新验机?',
      className: 'repair-dialog',
    })
    showToastLoading()
    await applyVerifyDevice(item.guid)
    showToastFail('申请成功')
    queryHandle()
  } catch (error) {
    if (error) {
      let message = error?.message || '申请失败'
      showToastFail(message)
    }
    console.log('error', error)
  }
}
function applyInvoice(item: OrderListItem) {
  $router.push({
    name: 'jijia-apply-invoice',
    query: {
      guid: item.guid,
    },
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "我的极加订单" }),
    _createVNode(_unref(PullRefresh), {
      modelValue: _unref(refreshing),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(refreshing) ? (refreshing).value = $event : null)),
      onRefresh: _unref(onRefresh),
      class: "list-wrap"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(List), {
          loading: _unref(loading),
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => (_isRef(loading) ? (loading).value = $event : null)),
          error: _unref(requestError),
          "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => (_isRef(requestError) ? (requestError).value = $event : null)),
          finished: _unref(finished),
          offset: 200,
          "finished-text": _unref(finishedText),
          "error-text": "加载失败",
          onLoad: _unref(queryHandle),
          class: "list-container"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.serial_number,
                class: "van-hairline--surround list-item"
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _hoisted_2,
                  _createElementVNode("div", null, _toDisplayString(item.order_no), 1)
                ]),
                _createVNode(BaseInfoList, {
                  list: item.orderInfo,
                  listItemJustifyContent: "space-between",
                  listItemMt: 8,
                  class: "van-hairline--top"
                }, null, 8, ["list"]),
                _createVNode(BaseInfoList, {
                  list: item.snInfo,
                  class: "van-hairline--top",
                  labelWidth: "100%"
                }, null, 8, ["list"]),
                (item.buttonTips || item.showApplyInvoiceButton || item.showVerifyDeviceButton)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (item.showApplyInvoiceButton)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "*30天内可申请开票！"))
                        : _createCommentVNode("", true),
                      (item.showApplyInvoiceButton)
                        ? (_openBlock(), _createBlock(_unref(Button), {
                            key: 1,
                            block: "",
                            class: "xa-vant-button",
                            type: "success",
                            onClick: ($event: any) => (applyInvoice(item)),
                            round: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("申请发票")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (item.showVerifyDeviceButton)
                        ? (_openBlock(), _createBlock(_unref(Button), {
                            key: 2,
                            block: "",
                            type: "success",
                            class: "xa-vant-button",
                            round: "",
                            onClick: ($event: any) => (applyVerifyAgain(item))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("申请重新验机")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "error", "finished", "finished-text", "onLoad"])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"])
  ], 64))
}
}

})